import {
  AppBar,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItem,
  Box,
  ListItemText,
  Avatar,
  Link,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Fragment } from "react";

const drawerWidth = 240;

const Header = ({ OnLogout }) => {
  return (
    <Fragment>
      <AppBar
        position="fixed"
        sx={{ zIndex: 1201, backgroundColor: "#313131", py: 1 }}
      >
        <Toolbar sx={{ display: "flex", alignItems: "center" }}>
          <Box
            component="img"
            src="/images/logo-white-connvisor.png"
            alt="Connvisor Leads"
            sx={{ height: 80, mr: 2 }}
          />
          <Typography variant="h6" color="#fff" noWrap>
            Connvisor Leads Manager
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          },
        }}
      >
        <Box sx={{ overflow: "auto", mt: "100px" }}>
          <Box mt={4} display={"flex"} justifyContent={"center"}>
            <Avatar
              alt={localStorage.getItem("name")}
              src={localStorage.getItem("profile_image")}
              sx={{ width: 100, height: 100 }}
            />
          </Box>
          <Box mb={4} textAlign={"center"}>
            <Link
              component="button"
              variant="body2"
              onClick={OnLogout}
              underline="hover"
            >
              Logout
            </Link>
          </Box>
          <List>
            {[
              { name: "Leads", path: "/" },
              { name: "Proposals Generator", path: "/backlinks" },
              { name: "Marketing", path: "/tasks" },
              { name: "Settings", path: "/tasks" },
            ].map((item) => (
              <ListItem
                button
                component={RouterLink}
                to={item.path}
                key={item.name}
              >
                <ListItemText primary={item.name} />
              </ListItem>
            ))}
          </List>
        </Box>
        {/* Sticky footer */}
        <Box sx={{ p: 2, borderTop: "1px solid #e0e0e0", textAlign: "center" }}>
          <Typography variant="caption" color="text.primary">
            Powered by:
          </Typography>
          <Box
            component="img"
            src="/images/connvisor.webp"
            sx={{ height: 40, mb: 1 }}
            display={"block"}
            mx={"auto"}
          />

          <Typography variant="caption" color="text.secondary" display="block">
            Version 1.0
          </Typography>
        </Box>
      </Drawer>
    </Fragment>
  );
};
export default Header;
